import '../plugins/carouselPlugin';

// slick init
export default function initSlickCarousel() {
	jQuery('.slick-slider').slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev">Previous</button>',
		nextArrow: '<button class="slick-next">Next</button>',
		centerMode: true,
		centerPadding: '0px',

		speed: 1000,
		autoplay: false,
		autoplaySpeed: 5000,
		variableWidth: true,
	});

	jQuery('.foot-logo-slider').slick({
		slidesToScroll: 1,
        slidesToShow: 3,
		rows: 0,
        mobileFirst: true,
		prevArrow: '<button class="slick-prev">Previous</button>',
		nextArrow: '<button class="slick-next">Next</button>',
		responsive: [{
			breakpoint: 576,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 4
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 6
			}
		}, {
			breakpoint: 1200,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 8
			}
		}, {
			breakpoint: 1399,
			settings: {
				slidesToScroll: 1,
				slidesToShow: 9
			}
		}]
	});
}